import React from 'react';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Divider from '@mui/material/Divider';
import { NavLink } from 'react-router-dom';
import { FaHome, FaUser, FaEnvelope, FaTrophy, FaUserShield, FaClipboardList } from 'react-icons/fa';
import { Box, Typography } from '@mui/material';
import logo from "../media/TCOpfingen_Logo.png";
import { useAuth } from '../provider/auth';

const drawerWidth = 240;

const Sidebar = ({ mobileOpen, setMobileOpen }) => {
  const { user } = useAuth();

  const menuItems = [
    { text: 'Buchen', icon: <FaHome />, path: '/' },
    { text: 'Turniere', icon: <FaClipboardList />, path: '/tournaments' },
    { text: 'Konto', icon: <FaUser />, path: '/account' },
    { text: 'Kontakt', icon: <FaEnvelope />, path: '/contact' },
    { text: 'Ergebnisse', icon: <FaTrophy />, path: '/results' },
  ];

  const adminItems = [
    { text: 'Dashboard', path: '/admin/dashboard' },
    { text: 'Mitglieder', path: '/admin/members' },
    { text: 'Buchungen', path: '/admin/bookings' },
    { text: 'Gastspieler', path: '/admin/guests' },
    { text: 'Termine', path: '/admin/events' },
    { text: 'Turniere', path: '/admin/tournaments' },
    { text: 'Verein', path: '/admin/club' },
  ];

  const drawer = (
    <Box>
      <Box sx={{ p: 2, textAlign: 'center' }}>
        <img src={logo} alt="Logo" style={{ height: 18, marginBottom: '8px' }} />
      </Box>
      <Divider />
      
      <Typography variant="caption" sx={{ px: 2, py: 1, display: 'block', color: 'text.secondary', fontWeight: 'bold' }}>
        Allgemein
      </Typography>
      <List>
        {menuItems.map((item) => (
          <ListItem
            button
            key={item.text}
            component={NavLink}
            to={item.path}
            onClick={() => setMobileOpen(false)}
            sx={{
              '&.active': {
                bgcolor: 'action.selected',
                borderLeft: '4px solid',
                borderColor: 'primary.main',
              },
            }}
          >
            <ListItemIcon sx={{ minWidth: 40 }}>{item.icon}</ListItemIcon>
            <ListItemText primary={item.text} />
          </ListItem>
        ))}
      </List>

      {user?.role === 2 && (
        <>
          <Divider />
          <Typography variant="caption" sx={{ px: 2, py: 1, display: 'block', color: 'text.secondary', fontWeight: 'bold' }}>
            Administration
          </Typography>
          <List>
            {adminItems.map((item) => (
              <ListItem
                button
                key={item.text}
                component={NavLink}
                to={item.path}
                onClick={() => setMobileOpen(false)}
                sx={{
                  '&.active': {
                    bgcolor: 'action.selected',
                    borderLeft: '4px solid',
                    borderColor: 'primary.main',
                  },
                }}
              >
                <ListItemIcon sx={{ minWidth: 40 }}>
                  <FaUserShield />
                </ListItemIcon>
                <ListItemText primary={item.text} />
              </ListItem>
            ))}
          </List>
        </>
      )}
    </Box>
  );

  return (
    <Box component="nav">
      <Drawer
        variant="temporary"
        open={mobileOpen}
        onClose={() => setMobileOpen(false)}
        ModalProps={{ keepMounted: true }}
        sx={{
          display: { xs: 'block', md: 'none' },
          '& .MuiDrawer-paper': {
            boxSizing: 'border-box',
            width: drawerWidth,
            bgcolor: 'rgba(255, 255, 255, 0.9)',
            backdropFilter: 'blur(10px)'
          },
        }}
      >
        {drawer}
      </Drawer>
    </Box>
  );
};

export default Sidebar;
